module.exports = [
  {
    band: 26,
    bust: 27,
    bra: '30A',
  },
  {
    band: 26,
    bust: 28,
    bra: '30B',
  },
  {
    band: 26,
    bust: 29,
    bra: '30C',
  },
  {
    band: 26,
    bust: 30,
    bra: '30D',
  },
  {
    band: 26,
    bust: 31,
    bra: '30DD/E',
  },
  {
    band: 26,
    bust: 32,
    bra: '30DDD/F',
  },
  {
    band: 26,
    bust: 33,
    bra: '30G',
  },
  {
    band: 27,
    bust: 28,
    bra: '30A',
  },
  {
    band: 27,
    bust: 29,
    bra: '30B',
  },
  {
    band: 27,
    bust: 30,
    bra: '30C',
  },
  {
    band: 27,
    bust: 31,
    bra: '30D',
  },
  {
    band: 27,
    bust: 32,
    bra: '30DD/E',
  },
  {
    band: 27,
    bust: 33,
    bra: '30DDD/G',
  },
  {
    band: 27,
    bust: 34,
    bra: '30G',
  },

  {
    band: 28,
    bust: 29,
    bra: '32A',
  },
  {
    band: 28,
    bust: 30,
    bra: '32B',
  },
  {
    band: 28,
    bust: 31,
    bra: '32C',
  },
  {
    band: 28,
    bust: 32,
    bra: '32D',
  },
  {
    band: 28,
    bust: 33,
    bra: '32DD/E',
  },
  {
    band: 28,
    bust: 34,
    bra: '32DDD/F',
  },
  {
    band: 28,
    bust: 35,
    bra: '32G',
  },
  {
    band: 28,
    bust: 36,
    bra: '32H',
  },
  {
    band: 29,
    bust: 30,
    bra: '32A',
  },
  {
    band: 29,
    bust: 31,
    bra: '32B',
  },
  {
    band: 29,
    bust: 32,
    bra: '32C',
  },
  {
    band: 29,
    bust: 33,
    bra: '32D',
  },
  {
    band: 29,
    bust: 34,
    bra: '32DD/E',
  },
  {
    band: 29,
    bust: 35,
    bra: '32DDD/F',
  },
  {
    band: 29,
    bust: 36,
    bra: '32G',
  },
  {
    band: 29,
    bust: 37,
    bra: '32H',
  },
  {
    band: 30,
    bust: 31,
    bra: '34A',
  },
  {
    band: 30,
    bust: 32,
    bra: '34B',
  },
  {
    band: 30,
    bust: 33,
    bra: '34C',
  },
  {
    band: 30,
    bust: 34,
    bra: '34D',
  },
  {
    band: 30,
    bust: 35,
    bra: '34DD/E',
  },
  {
    band: 30,
    bust: 36,
    bra: '34DDD/F',
  },
  {
    band: 30,
    bust: 37,
    bra: '34G',
  },
  {
    band: 30,
    bust: 38,
    bra: '34H',
  },
  {
    band: 30,
    bust: 39,
    bra: '34I',
  },
  {
    band: 31,
    bust: 32,
    bra: '34A',
  },
  {
    band: 31,
    bust: 33,
    bra: '34B',
  },
  {
    band: 31,
    bust: 34,
    bra: '34C',
  },
  {
    band: 31,
    bust: 35,
    bra: '34D',
  },
  {
    band: 31,
    bust: 36,
    bra: '34DD/E',
  },
  {
    band: 31,
    bust: 37,
    bra: '34DDD/F',
  },
  {
    band: 31,
    bust: 38,
    bra: '34G',
  },
  {
    band: 31,
    bust: 39,
    bra: '34H',
  },
  {
    band: 31,
    bust: 40,
    bra: '34I',
  },
  {
    band: 32,
    bust: 33,
    bra: '34A',
  },
  {
    band: 32,
    bust: 34,
    bra: '34B',
  },
  {
    band: 32,
    bust: 35,
    bra: '34C',
  },
  {
    band: 32,
    bust: 36,
    bra: '34D',
  },
  {
    band: 32,
    bust: 37,
    bra: '34DD/E',
  },
  {
    band: 32,
    bust: 38,
    bra: '34DDD/F',
  },
  {
    band: 32,
    bust: 39,
    bra: '34G',
  },
  {
    band: 32,
    bust: 40,
    bra: '34H',
  },
  {
    band: 32,
    bust: 41,
    bra: '34I',
  },
  {
    band: 33,
    bust: 34,
    bra: '36A',
  },
  {
    band: 33,
    bust: 35,
    bra: '36B',
  },
  {
    band: 33,
    bust: 36,
    bra: '36C',
  },
  {
    band: 33,
    bust: 37,
    bra: '36D',
  },
  {
    band: 33,
    bust: 38,
    bra: '36DD/E',
  },
  {
    band: 33,
    bust: 39,
    bra: '36DDD/F',
  },
  {
    band: 33,
    bust: 40,
    bra: '36G',
  },
  {
    band: 33,
    bust: 41,
    bra: '36H',
  },
  {
    band: 33,
    bust: 42,
    bra: '36I',
  },
  {
    band: 34,
    bust: 35,
    bra: '36A',
  },
  {
    band: 34,
    bust: 36,
    bra: '36B',
  },
  {
    band: 34,
    bust: 37,
    bra: '36C',
  },
  {
    band: 34,
    bust: 38,
    bra: '36D',
  },
  {
    band: 34,
    bust: 39,
    bra: '36DD/E',
  },
  {
    band: 34,
    bust: 40,
    bra: '36DDD/F',
  },
  {
    band: 34,
    bust: 41,
    bra: '36G',
  },
  {
    band: 34,
    bust: 42,
    bra: '36H',
  },
  {
    band: 34,
    bust: 43,
    bra: '36I',
  }, {
    band: 35,
    bust: 37,
    bra: '38B',
  },
  {
    band: 35,
    bust: 38,
    bra: '38C',
  },
  {
    band: 35,
    bust: 39,
    bra: '38D',
  },
  {
    band: 35,
    bust: 40,
    bra: '38DD/E',
  },
  {
    band: 35,
    bust: 41,
    bra: '38DDD/F',
  },
  {
    band: 35,
    bust: 42,
    bra: '38G',
  },
  {
    band: 35,
    bust: 43,
    bra: '38H',
  },
  {
    band: 35,
    bust: 44,
    bra: '38I',
  }, {
    band: 36,
    bust: 38,
    bra: '38B',
  },
  {
    band: 36,
    bust: 39,
    bra: '38C',
  },
  {
    band: 36,
    bust: 40,
    bra: '38D',
  },
  {
    band: 36,
    bust: 41,
    bra: '38DD/E',
  },
  {
    band: 36,
    bust: 42,
    bra: '38DDD/F',
  },
  {
    band: 36,
    bust: 43,
    bra: '38G',
  },
  {
    band: 36,
    bust: 44,
    bra: '38H',
  },
  {
    band: 36,
    bust: 46,
    bra: '38I',
  },
  {
    band: 37,
    bust: 39,
    bra: '38B',
  },
  {
    band: 37,
    bust: 40,
    bra: '38C',
  },
  {
    band: 37,
    bust: 41,
    bra: '38D',
  },
  {
    band: 37,
    bust: 42,
    bra: '38DD/E',
  },
  {
    band: 37,
    bust: 43,
    bra: '38DDD/F',
  },
  {
    band: 37,
    bust: 44,
    bra: '38G',
  },
  {
    band: 37,
    bust: 46,
    bra: '38H',
  },
  {
    band: 37,
    bust: 48,
    bra: '38I',
  }, {
    band: 38,
    bust: 40,
    bra: '38B',
  },
  {
    band: 38,
    bust: 41,
    bra: '38C',
  },
  {
    band: 38,
    bust: 42,
    bra: '38D',
  },
  {
    band: 38,
    bust: 43,
    bra: '38DD/E',
  },
  {
    band: 38,
    bust: 44,
    bra: '38DDD/F',
  },
  {
    band: 38,
    bust: 46,
    bra: '38G',
  },
  {
    band: 38,
    bust: 48,
    bra: '38H',
  },
  {
    band: 38,
    bust: 50,
    bra: '38I',
  }, {
    band: 39,
    bust: 41,
    bra: '40B',
  },
  {
    band: 39,
    bust: 42,
    bra: '40C',
  },
  {
    band: 39,
    bust: 43,
    bra: '40D',
  },
  {
    band: 39,
    bust: 44,
    bra: '40DD/E',
  },
  {
    band: 39,
    bust: 46,
    bra: '40DDD/F',
  },
  {
    band: 39,
    bust: 48,
    bra: '40G',
  },
  {
    band: 39,
    bust: 50,
    bra: '40H',
  }, {
    band: 40,
    bust: 42,
    bra: '40B',
  },
  {
    band: 40,
    bust: 43,
    bra: '40C',
  },
  {
    band: 40,
    bust: 44,
    bra: '40D',
  },
  {
    band: 40,
    bust: 46,
    bra: '40DD/E',
  },
  {
    band: 40,
    bust: 48,
    bra: '40DDD/F',
  },
  {
    band: 40,
    bust: 50,
    bra: '40G',
  },
  {
    band: 40,
    bust: 52,
    bra: '40H',
  }, {
    band: 41,
    bust: 43,
    bra: '40B',
  },
  {
    band: 41,
    bust: 44,
    bra: '40C',
  },
  {
    band: 41,
    bust: 46,
    bra: '40D',
  },
  {
    band: 41,
    bust: 48,
    bra: '40DD/E',
  },
  {
    band: 41,
    bust: 50,
    bra: '40DDD/F',
  },
  {
    band: 41,
    bust: 52,
    bra: '40G',
  },
  {
    band: 41,
    bust: 54,
    bra: '40H',
  }, {
    band: 42,
    bust: 46,
    bra: '42C',
  },
  {
    band: 42,
    bust: 48,
    bra: '42D',
  },
  {
    band: 42,
    bust: 50,
    bra: '42DD/E',
  },
  {
    band: 42,
    bust: 52,
    bra: '42DDD/F',
  },
  {
    band: 42,
    bust: 54,
    bra: '42G',
  },
  {
    band: 42,
    bust: 56,
    bra: '42H',
  }, {
    band: 43,
    bust: 48,
    bra: '44C',
  },
  {
    band: 43,
    bust: 50,
    bra: '44D',
  },
  {
    band: 43,
    bust: 52,
    bra: '44DD/E',
  },
  {
    band: 43,
    bust: 54,
    bra: '44DDD/F',
  },
  {
    band: 43,
    bust: 56,
    bra: '44G',
  },
  {
    band: 43,
    bust: 57,
    bra: '44H',
  }, {
    band: 44,
    bust: 50,
    bra: '44C',
  },
  {
    band: 44,
    bust: 52,
    bra: '44D',
  },
  {
    band: 44,
    bust: 54,
    bra: '44DD/E',
  },
  {
    band: 44,
    bust: 56,
    bra: '44DDD/F',
  },
  {
    band: 44,
    bust: 57,
    bra: '44G',
  },
  {
    band: 44,
    bust: 58,
    bra: '44H',
  },
];



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/js/braFinderCalculatorSizes.js